import { IPhoneData } from "./type";

export const getFullPhoneNumber = ({ countryCode, telephone }: IPhoneData) => {
  return `${countryCode}${telephone}`;
};
